import {
  RegistrationData,
  RegistrationStepConfigItem
} from "../types/registrationTypes";
import {
  BusinessType,
  CountryFullName,
  getEmptyCompanyAddress
} from "@kivunova/kivufrontendcommon";
import { DEFAULT_VAT_CALCULATION_MODE } from "../../Company/constants/companyVatConstants";

export const RegistrationStepConfig: RegistrationStepConfigItem[] = [
  {
    titleTranslationKey: "registration-step-admin",
    title: "Personal Info",
    labelText: "Tell us about yourself to personalize your experience.",
    labelTranslationKey: "admin-info-title"
  },
  {
    titleTranslationKey: "registration-step-company",
    title: "Company Info",
    labelText: "Let’s learn more about your company",
    labelTranslationKey: "company-info-title"
  },
  {
    titleTranslationKey: "registration-step-review",
    title: "Review & Submit",
    labelText: "Take a moment to review your information — you’re almost done!",
    labelTranslationKey: "review-and-submit-info-title"
  }
];

export const defaultRegistrationValues: RegistrationData = {
  company: {
    name: "",
    businessType: BusinessType.RETAIL,
    currencyCode: "RWF",
    registrationNumber: "",
    description: "",
    vatPercentage: 18,
    vatCalculationMode: DEFAULT_VAT_CALCULATION_MODE,
    address: getEmptyCompanyAddress(CountryFullName.RW)
  },
  admin: {
    // admin
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    profileImage: "",
    phoneCountryCode: ""
  }
};
